// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.finish-actions[data-v-656288ba] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  margin-top: 30px;\n}\n.finish-actions__button-wrapper[data-v-656288ba] {\n  display: block;\n  width: 100%;\n  max-width: 265px;\n}\n@media (max-width: 767px) {\n.finish-actions[data-v-656288ba] {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n.finish-actions__button-wrapper[data-v-656288ba] {\n    max-width: 100%;\n}\n}\n", ""]);
// Exports
module.exports = exports;
